
import api from "../../../../api/api"

const getTransactionList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/transaction").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getStockList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/stock").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const add = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/inventory/add",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getBillingStock = (companyId,productId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory/stock/"+companyId+"/"+productId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const inventoryServices = {
    getTransactionList,
    getStockList,
    getBillingStock,
    add,
}
export default inventoryServices;